import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
    key: 0,
    class: "form__legend"
};
import { watch } from 'vue';
import { get, set } from 'lodash';
import FormValidator from "./FormValidator";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormFields',
    props: {
        form: {},
        fields: {},
        data: {},
        validation: {},
        mode: {},
        legend: {},
        submitted: { type: Boolean },
        disabled: { type: Boolean },
        fieldPrefix: {}
    },
    emits: [
        'fieldChange',
        'change',
        'bulkSelectToggle',
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        validate();
        watch(props.fields, validate, { deep: true });
        watch(props.data, validate, { deep: true });
        function fieldData(field) {
            const data = get(props.data, field.name);
            if (data === null || data === undefined) {
                // Init empty object for nested fields
                if (field.type === 'form') {
                    set(props.data, field.name, (field.options && field.options.collection) ? [] : {});
                    validate();
                    return get(props.data, field.name);
                }
                if (field.type === 'bool' && field.options?.required) {
                    set(props.data, field.name, false);
                    validate();
                    return get(props.data, field.name);
                }
            }
            return data;
        }
        function onChange(field, data) {
            set(props.data, field.name, data);
            validate();
            log('FormFields@change', field.name, data);
            emit('fieldChange', field.name, data);
            emit('change', props.data);
        }
        function validate() {
            log('validate');
            const validation = FormValidator.validate(props.fields, props.data, props.fieldPrefix ?? '');
            props.validation.errors = [];
            props.validation.fields = { ...(props.validation ?? { errors: [], fields: {} }).fields, ...validation.fields };
        }
        function onBulkSelectToggle(fieldPath) {
            emit('bulkSelectToggle', fieldPath);
        }
        return (_ctx, _cache) => {
            const _component_form_group = _resolveComponent("form-group");
            return (_openBlock(), _createElementBlock("fieldset", {
                class: "form__field-set",
                disabled: __props.disabled
            }, [
                (__props.legend)
                    ? (_openBlock(), _createElementBlock("legend", _hoisted_2, _toDisplayString(__props.legend), 1))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                    return (_openBlock(), _createBlock(_component_form_group, {
                        key: field.name,
                        form: __props.form,
                        field: field,
                        "field-prefix": __props.fieldPrefix ?? '',
                        data: fieldData(field),
                        validation: __props.validation,
                        submitted: __props.submitted,
                        disabled: __props.disabled,
                        mode: __props.mode,
                        onChange: ($event) => (onChange(field, $event)),
                        onBulkSelectToggle: onBulkSelectToggle
                    }, null, 8, ["form", "field", "field-prefix", "data", "validation", "submitted", "disabled", "mode", "onChange"]));
                }), 128))
            ], 8, _hoisted_1));
        };
    }
});
